import { useMemo, useRef, useState } from 'react';
import './ProgressPage.scss';

const ProgressPage = ({ isOpen, onClose }) => {
  const pageRef = useRef(null);
  const isMobile = useMemo(() => window.innerWidth <= 1024, []);
  const [selectedGallery, setSelectedGallery] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Sample data for progress timeline using available images
  const progressData = [
    {
      id: 1,
      date: '09/2025',

      images: [
        '/assets/jasari-images/progress/9-2025/progress.jpg',
        '/assets/jasari-images/progress/9-2025/progress.jpg',
        '/assets/jasari-images/progress/9-2025/progress.jpg',
        '/assets/jasari-images/progress/9-2025/progress.jpg',
      ],
    },
    {
      id: 2,
      date: '11/2025',

      images: [
        '/assets/jasari-images/progress/11-2025/1.webp',
        '/assets/jasari-images/progress/11-2025/2.webp',
        '/assets/jasari-images/progress/11-2025/3.webp',
        '/assets/jasari-images/progress/11-2025/4.webp',
        '/assets/jasari-images/progress/11-2025/5.webp',
        '/assets/jasari-images/progress/11-2025/6.webp',
        '/assets/jasari-images/progress/11-2025/7.webp',
        '/assets/jasari-images/progress/11-2025/8.webp',
      ],
    },
    {
      id: 3,
      date: 'Coming soon',

      images: ['/assets/jasari-images/coming_soon-img.webp'],
    },
    {
      id: 4,
      date: 'Coming soon',

      images: ['/assets/jasari-images/coming_soon-img.webp'],
    },
  ];

  const handleItemClick = (item) => {
    // console.log('🚀 ~ handleItemClick ~ item:', item);
    if (item.date === 'Coming soon') return;
    setSelectedGallery(item);
    setCurrentImageIndex(0);
  };

  const handleCloseGallery = () => {
    setSelectedGallery(null);
    setCurrentImageIndex(0);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? selectedGallery.images.length - 1 : prev - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) =>
      prev === selectedGallery.images.length - 1 ? 0 : prev + 1
    );
  };

  if (!isOpen) return null;

  return (
    <div
      className="progress-page"
      ref={pageRef}
      style={{
        width: `${
          document.body.classList.contains('menu-open') && !isMobile
            ? 'calc(100vw - 260px)'
            : '100vw'
        }`,
        height: `${isMobile ? 'calc(100dvh - 50px)' : '100dvh'}`,
      }}
    >
      <div className="progress-page__container">
        <div className="progress-page__header">
          <div className="progress-page__title">
            <div className="logo">
              <img
                src="/assets/khp-images/tour/e055c252-77cb-488d-a256-4a2c0fc46cf2.jpg"
                alt="logo"
              />
            </div>
            <h2 className="project-subtitle">TIẾN ĐỘ DỰ ÁN</h2>
          </div>
        </div>

        <div className="progress-page__content">
          <div className="progress-timeline">
            {progressData.map((item, index) => (
              <div
                key={item.id}
                className="progress-item"
                onClick={() => handleItemClick(item)}
              >
                <div className="progress-item__image">
                  <img
                    src={item.images[0]}
                    alt={item.title}
                    onError={(e) => {
                      e.target.src =
                        '/assets/jasari-images/media/jasari-ho-boi.jpg';
                    }}
                  />
                  <div className="progress-item__overlay">
                    <div className="progress-item__date">{item.date}</div>
                  </div>
                </div>
                {/* <div className="progress-item__content">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div> */}
              </div>
            ))}
          </div>
        </div>

        {/* Gallery Modal */}
        {selectedGallery && (
          <div className="gallery-modal" onClick={handleCloseGallery}>
            <div
              className="gallery-modal__container"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="gallery-modal__close"
                onClick={handleCloseGallery}
              >
                ×
              </button>

              <div className="gallery-modal__content">
                <div className="gallery-modal__main-image">
                  <img
                    src={selectedGallery.images[currentImageIndex]}
                    alt={selectedGallery.title}
                    onError={(e) => {
                      e.target.src =
                        '/assets/jasari-images/media/jasari-ho-boi.jpg';
                    }}
                  />

                  {selectedGallery.images.length > 1 && (
                    <>
                      <button
                        className="gallery-modal__nav gallery-modal__prev"
                        onClick={handlePrevImage}
                      >
                        &#8249;
                      </button>
                      <button
                        className="gallery-modal__nav gallery-modal__next"
                        onClick={handleNextImage}
                      >
                        &#8250;
                      </button>
                    </>
                  )}
                </div>

                <div className="gallery-modal__thumbnails">
                  {selectedGallery.images.map((image, index) => (
                    <div
                      key={index}
                      className={`gallery-modal__thumbnail ${
                        index === currentImageIndex ? 'active' : ''
                      }`}
                      onClick={() => setCurrentImageIndex(index)}
                    >
                      <img
                        src={image}
                        alt={`${selectedGallery.title} ${index + 1}`}
                        onError={(e) => {
                          e.target.src =
                            '/assets/jasari-images/media/jasari-ho-boi.jpg';
                        }}
                      />
                    </div>
                  ))}
                </div>

                <div className="gallery-modal__info">
                  <h3>{selectedGallery.date}</h3>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressPage;
